import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Card extends React.Component
{
    static propTypes = {
        className: PropTypes.string,
        header: PropTypes.any,
        footer: PropTypes.any,
        scroll: PropTypes.bool,
        tight: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        header: null,
        footer: null,
        scroll: false,
        tight: false,
    };

    render()
    {
        const classes = classNames({
            [this.props.className]: true,
            'flex flex-col bg-white shadow rounded-lg': true,
        });

        const innerClasses = classNames({
            'flex-grow': true,
            'px-4 py-5 sm:p-6': ! this.props.tight,
            'overflow-scroll': this.props.scroll
        });

        return <div className={classes}>
            {this.props.header}
            <div className={innerClasses}>
                {this.props.children}
            </div>
            {this.props.footer}
        </div>;
    }
}

export class CardHeader extends React.Component
{
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        action: PropTypes.any
    };

    static defaultProps = {
        action: null
    };

    render()
    {
        const classes = classNames({
            [this.props.className]: true,
            ['px-4 py-5 border-b border-gray-200 sm:px-6']: true,
        });

        return <div className={classes}>
            <div className="-ml-4 -mt-4 flex justify-between flex-wrap sm:flex-nowrap">
                <div className="ml-4 mt-4">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                        {this.props.title}
                    </h3>
                </div>
                <div className="ml-4 mt-3 -mr-2 flex-shrink-0">
                    {this.props.action}
                </div>
            </div>
            {
                this.props.children
            }
        </div>;
    }
}

export class CardFooter extends React.Component
{
    static propTypes = {
        className: PropTypes.string,
    };

    render()
    {
        const classes = classNames({
            [this.props.className]: true,
            'bg-gray-50 px-4 py-4 rounded-b-lg sm:px-6': true,
        });

        return <div className={classes}>
            {this.props.children}
        </div>
    }
}
